import Icon from './Icon';

const FAQLinkList = ({ faqs, title, className }: { faqs: { question: string; link: string }[]; title: string; className?: string }) => {
  return (
    <div className={`faq-list mb-0 ${className || ''}`.trim()}>
      <h2 className="text-lg font-bold mb-2">{title}</h2>
      <ul className="list-none list-inside grid md:grid-cols-2 grid-cols-1 gap-theme-xs">
        {faqs.map((faq, index) => (
          <li key={index} className="mb-2 py-1">
            <a href={faq.link} className="text-theme-link flex items-center gap-2" target="_blank" rel="noopener noreferrer">
              <div>
                <Icon name="question-circle" />
              </div>
              <div>{faq.question}</div>
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FAQLinkList;
